import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from './modules/authentication/models/user.model';
import { CommonService } from '@tamilarasitech/tt-branding-app-lib';
import { BrandingService } from '@tamilarasitech/tt-branding-app-lib';
import { Router } from '@angular/router';
import { MessageService } from '@tamilarasitech/tt-branding-app-lib';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogPopupComponent } from '@tamilarasitech/tt-branding-app-lib';
import { AppMaterialModule } from '@tamilarasitech/tt-branding-app-lib';
import { TtUIComponentsModule } from '@tamilarasitech/tt-branding-app-lib';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, AppMaterialModule, TtUIComponentsModule],
})
export class AppComponent implements AfterViewInit {
  title: string = 'Admin';
  copyright: string = '';

  _user: BehaviorSubject<any> = new BehaviorSubject({});
  readonly user$?: Observable<any>;

  @ViewChild('sidenav') sidenav?: MatSidenav;
  sidenavOpened: boolean = false;

  user: User = {} as User;
  config: any;
  isHandset$?: Observable<boolean>;
  isHandset: boolean = false;
  year: number = new Date().getFullYear();

  constructor(
    private authService: AuthService,
    private branding: BrandingService,
    private titleService: Title,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private router: Router
  ) {
    this.user$ = this.authService.currentUser$;
    this.authService.currentUser$.subscribe((user: any) => {
      this.user = user;
      console.log('[App Debug] currentuser$ updated:', {
        uid: (user as any)?.uid,
        authenticated: (user as any)?.authenticated,
        role: (user as any)?.role,
        roles: (user as any)?.roles,
      });
    });
    this.isHandset$ = this.commonService.isHandset$;
    this.isHandset$.subscribe((value) => {
      this.isHandset = !!value;
      console.log('[App Debug] isHandset updated:', { isHandset: this.isHandset });
    });
    this.messageService.message$.subscribe((message: any) => {
      if (message.status && message.text) this.openDialog(message);
    });
  }
  ngAfterViewInit(): void {
    queueMicrotask(() => {
      this.sidenavOpened = !!this.sidenav?.opened;
      console.log('[App Debug] sidenav opened:', { opened: this.sidenavOpened });
    });
  }

  ngOnInit(): void {
    this.branding.config$.subscribe((data: any) => {
      this.config = data;
      this.title = this.config?.app?.title || 'Admin';
      this.copyright = this.config?.legal?.copyright || '';
      this.titleService.setTitle(this.config?.app?.title || 'Admin');
    });
  }

  closeSideNav(force: boolean) {
    console.log('[App Debug] closeSideNav called:', {
      force,
      mode: this.sidenav?.mode,
      opened: this.sidenav?.opened,
    });
    if (Boolean(force) || this.sidenav?.mode === 'over') {
      this.sidenav?.close();
    }
  }

  toggleProfile() {
    const url = this.router.url || '';
    if (url.startsWith('/profile')) {
      this.router.navigate(['/dashboard']);
      return;
    }

    try {
      this.sidenav?.close();
    } catch {
      // ignore
    }
    this.router.navigate(['/profile']);
  }

  onLogout(user: any) {
    console.log('[App Debug] logout clicked');
    try {
      this.sidenav?.close();
    } catch {
      // ignore
    }

    this.authService
      .signOut()
      .catch(() => {
        // ignore
      })
      .finally(() => {
        this.router.navigate(['/auth/login']);
      });
  }

  onSidenavOpenedChange(opened: boolean) {
    console.log('[App Debug] sidenav openedChange:', { opened });
    this.sidenavOpened = opened;
  }

  dialog = inject(MatDialog);
  dialogRef: any;
  openDialog(message: any) {
    this.dialogRef = this.dialog.open(MessageDialogPopupComponent, {
      data: { message },
      hasBackdrop: true,
      disableClose: false,
    });
  }
}
